export const destinations = ["Factory", "The Store", "Amazon CA", "Amazon US", "Walmart US"];
